import "./Button.css";

const Button = (props) => {
  return (
    <button
      className={`btn ${"btn--" + props.btntype}`}
      onClick={props.handleclick}
      style={props.style}
      disabled={props.disabled}
    >
      {props.icon}
      {props.children}
    </button>
  );
};
export default Button;
